import { FC } from "react";
import { useDispatch } from "react-redux";

import AddBrand from "../../components/AddBrand/AddBrand";
import AddNewBrandLayout from "../../layout/AddNewBrandLayout/AddNewBrandLayout";
import { useNavigate } from "react-router";
import { ERoutes } from "../../constants/routes";
import { fetchAddNewBrandCompetitors, setAddNewBrandBrand } from "../../store/brands/slice";
import { Company } from "../../store/auth/types";
import { fetchBrandRegister } from "../../store/auth/slice";

import styles from "./AddNewBrand.module.css";



const AddNewBrandView: FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = (brandSelected: Company) => {
    dispatch(fetchBrandRegister(brandSelected));
    dispatch(setAddNewBrandBrand(brandSelected));
    dispatch(fetchAddNewBrandCompetitors(brandSelected));
    navigate(ERoutes.AddNewBrandCompetitors);
  };

  return (
    <AddNewBrandLayout title="New Brand" >
      <AddBrand 
        classNameContainer={styles.addBrand} 
        classNameHeader={styles.addBrand__header} 
        classNameTitle={styles.addBrand__title} 
        classNameCaption={styles.addBrand__caption} 
        isShowMonitored={false} 
        onSubmit={handleSubmit} 
      />
    </AddNewBrandLayout>
  );
};

export default AddNewBrandView;
